import React from "react";
import { Link, useParams } from "react-router-dom";
import SEO, { JsonLd } from "../components/SEO";
import Reveal from "../components/Reveal";
import Breadcrumbs from "../components/Breadcrumbs";
import { useI18n, STR } from "../i18n";
import { BLOG, IMAGES } from "../mock";
import { Calendar, ArrowRight } from "lucide-react";

export function BlogList() {
  const { t, lang } = useI18n();
  return (
    <>
      <SEO title={{ es: "Blog", en: "Blog" }} path="/blog" description={{ es: "Artículos técnicos sobre suministro petrolero, seguridad industrial y logística.", en: "Technical articles on oilfield supply, industrial safety and logistics." }} />
      <JsonLd data={{ "@context": "https://schema.org", "@type": "Blog", name: "Grupo Inversiones Altamira Blog", url: "https://altamiravenezuela.com/blog", blogPost: BLOG.map(b => ({ "@type": "BlogPosting", headline: b.title[lang], datePublished: b.date, url: `https://altamiravenezuela.com/blog/${b.slug}` })) }} />
      <section className="hero phero">
        <div className="bg" style={{ backgroundImage: `url(${IMAGES.heroMain})` }} />
        <div className="shade" />
        <div className="container-x inner">
          <Breadcrumbs items={[{ label: { es: "Inicio", en: "Home" }, href: "/" }, { label: "Blog" }]} />
          <span className="eyebrow">Blog</span>
          <h1>{t({ es: "Conocimiento técnico y buenas prácticas", en: "Technical knowledge and best practices" })}</h1>
        </div>
      </section>
      <section className="section">
        <div className="container-x">
          <div className="grid-3">
            {BLOG.map((b, i) => (
              <Reveal key={b.slug} delay={i * 80}>
                <Link to={`/blog/${b.slug}`} className="card blog-card" style={{ display: "block", height: "100%" }}>
                  <div className="img" style={{ backgroundImage: `url(${b.cover})` }} />
                  <div className="body">
                    <div className="meta" style={{ marginBottom: 8 }}><Calendar size={12} style={{ display: "inline", verticalAlign: "-1px", marginRight: 4 }} />{new Date(b.date).toLocaleDateString(lang === "es" ? "es-VE" : "en-US", { year: "numeric", month: "long", day: "numeric" })}</div>
                    <h3>{t(b.title)}</h3>
                    <p>{t(b.excerpt)}</p>
                    <span style={{ color: "var(--navy)", fontWeight: 700, fontSize: 14, textTransform: "uppercase", letterSpacing: "0.06em" }}>{t(STR.cta.readMore)} <ArrowRight size={14} style={{ display: "inline", verticalAlign: "-2px" }} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const { t, lang } = useI18n();
  const post = BLOG.find(b => b.slug === slug);
  if (!post) return <section className="section"><div className="container-x" style={{ paddingTop: 100 }}><h1>Not found</h1><Link to="/blog">← Blog</Link></div></section>;

  return (
    <>
      <SEO title={post.title} path={`/blog/${slug}`} description={post.excerpt} image={post.cover} type="article" />
      <JsonLd data={{ "@context": "https://schema.org", "@type": "BlogPosting", headline: post.title[lang], image: post.cover, datePublished: post.date, author: { "@type": "Organization", name: "Grupo Inversiones Altamira" }, description: post.excerpt[lang] }} />
      <section className="hero phero">
        <div className="bg" style={{ backgroundImage: `url(${post.cover})` }} />
        <div className="shade" />
        <div className="container-x inner">
          <Breadcrumbs items={[{ label: { es: "Inicio", en: "Home" }, href: "/" }, { label: "Blog", href: "/blog" }, { label: post.title }]} />
          <span className="eyebrow"><Calendar size={12} style={{ display: "inline", verticalAlign: "-1px", marginRight: 6 }} />{new Date(post.date).toLocaleDateString(lang === "es" ? "es-VE" : "en-US", { year: "numeric", month: "long", day: "numeric" })}</span>
          <h1>{t(post.title)}</h1>
        </div>
      </section>
      <section className="section">
        <div className="container-x" style={{ maxWidth: 780 }}>
          <p style={{ fontSize: 20, lineHeight: 1.6, color: "#475066", fontStyle: "italic" }}>{t(post.excerpt)}</p>
          <p style={{ fontSize: 17, lineHeight: 1.85, color: "#354055", marginTop: 30 }}>{t(post.body)}</p>
          <Link to="/blog" className="btn btn-outline" style={{ marginTop: 40 }}>← Blog</Link>
        </div>
      </section>
    </>
  );
}
